import React from "react";
import { Outlet } from "react-router-dom";
import css from "classnames";
import styles from "./layout.module.css";

// <Footer to be merged with wide footer
export const Footer: React.FC = () => (
  <div className={styles.footer}>
    <div className={styles.wheelchair}></div>
    <div className={styles.equalhouse}></div>
    <div className={css("container", styles.container)}>
      Need help? Send us an email at&nbsp;
      <a href="mailto:support@havenconnect.com">support@havenconnect.com</a>
    </div>
  </div>
);

const Layout: React.FC = () => (
  <div className={styles.page}>
    <div className={css("container", styles.container)}>
      <div id="login-modal" />
    </div>
    <div className={styles.content}>
      <Outlet />
    </div>
    <Footer/>
  </div>
);

export default Layout;
